import { Mail } from "lucide-react";
import { IMAGES } from "@/lib/content";
import { NewsletterInline } from "@/components/site/Footer";

export function NewsletterSection() {
  return (
    <section className="relative isolate py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={IMAGES.sunsetSky} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ivory/80" />
      </div>
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="rounded-[2.5rem] bg-ink text-ivory p-10 md:p-16 text-center relative overflow-hidden" id="fab-lab">
          <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full bg-blush/20 blur-3xl" />
          <Mail className="mx-auto text-blush" size={28} />
          <p className="mt-5 label-eyebrow !text-champagne">Join The Community</p>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl">The Fab Lab</h2>
          <p className="mt-5 font-body text-ivory/75 max-w-xl mx-auto leading-relaxed">
            Leah's inner circle: track tips, healthy recipes, blog updates, Q&amp;A, and behind-the-scenes. Sign up free now and grow with the community as it becomes something bigger.
          </p>
          <div className="mt-8 flex justify-center"><NewsletterInline testidPrefix="home" /></div>
        </div>
      </div>
    </section>
  );
}
